import { useMutation } from "react-query";
import { addSingleCamera } from "../../../../actions/CarrierAgreementMgmt/Security";

const useAddSingleCamera = () => {
  return useMutation(addSingleCamera, {
    onSuccess: (data) => {
      if (data.status >= 400) {
        throw new Error(data.data || "Request failed");
      }
    },
    onError: (error) => {},
    useErrorBoundary: false,
  });
};
export default useAddSingleCamera;
